module.exports = __webpack_public_path__ + "static/media/TN-Women-Shoes.6b48ee58.svg";